import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {StorageUtils} from './utils/storage-utils';
import {UserBService} from './pages/ok-admin/user-b/user-b-service';
import {
    ROUTES_ADMIN,
    ROUTES_CUSTOMER,
    ROUTES_CUSTOMER_MEI,
    ROUTES_OPER,
    ROUTES_PARTNER
} from './shared/vertical-menu/vertical-menu-routes.config';
import {UserB} from './pages/ok-admin/user-b/user-b';
import {CustomizerService} from './shared/services/customizer.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;

    constructor(private router: Router,
                public translate: TranslateService,
                private storage: StorageUtils,
                private userBService: UserBService,
                public customizerService: CustomizerService) {
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang('pt-BR');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use('pt-BR');

        const loggedUser: UserB = this.storage.getLoggedUser();
        if (loggedUser != null) {
            if (loggedUser.info && loggedUser.info['darkMode']) {
                this.customizerService.switchLayout('dark', false)
            }
        }

        const rep = window.location.href.replace(/http(s)?:\/\/[^\/]*/g, '');
        if (rep === '/') {
            const userB = this.storage.getAutoLogin();
            if (userB != null) {
                this.userBService.autoLogin(userB, (result, user) => {
                    if (result.success) {

                        this.storage.storeToken(user.token);
                        this.storage.idUser(user.id);
                        this.storage.nameUser(user.name);
                        this.storage.roleId(user.idRole);


                        if (user.urlImage != null) {
                            this.storage.urlImage(user.urlImage);
                        }

                        if (user.idRole === 'admin') {
                            this.storage.urlHome(ROUTES_ADMIN[0].path);
                        }

                        if (user.idRole === 'oper') {
                            this.storage.urlHome(ROUTES_OPER[0].path);
                        }

                        if (user.type === 'CONTAZZ') {
                            if (user.idRole === 'admin') {
                                this.storage.urlHome(ROUTES_ADMIN[0].path);
                                window.location.href = ROUTES_ADMIN[0].path;
                            }

                            if (user.idRole === 'oper') {
                                this.storage.urlHome(ROUTES_OPER[0].path);
                                window.location.href = ROUTES_OPER[0].path;
                            }
                        } else {
                            if (user.idRole === 'partner') {
                                this.storage.urlHome(ROUTES_PARTNER[0].path);
                                window.location.href = ROUTES_PARTNER[0].path;
                            } else if (user.idRole === 'mei') {
                                this.storage.urlHome(ROUTES_CUSTOMER_MEI[0].path);
                                window.location.href = ROUTES_CUSTOMER_MEI[0].path;
                            } else {
                                this.storage.urlHome(ROUTES_CUSTOMER[0].path);
                                window.location.href = ROUTES_CUSTOMER[0].path;
                            }
                        }
                    } else {
                        this.router.navigate(['/pages/login']);
                    }
                });
            } else {
                this.router.navigate(['/pages/login']);
            }
        }
    }

    ngOnInit() {
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
